import { useMutation, useQueryClient } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IEditUserDTO } from "../../services/user-role-administration-service/Models";
import UserRoleAdministrationService from "../../services/user-role-administration-service/UserRoleAdministrationService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import { MfaSourceTypeEnum } from "../../common/enums/MfaSourceTypeEnum";

// export type UserMutationContextType = {
//     previous: IEditUserDTO;
// };


export type UseResetMfaParameters = {
    groupID: number;
} & BaseUseMutationParameters<void, number>;

export function useResetMfa({
    groupID,
    onError,
    onSuccess
}: UseResetMfaParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, number>(
        (userID) => {
            return UserRoleAdministrationService.resetMfa(groupID, userID);
        },
        {
            onMutate: async (userID) => {

                await queryClient.cancelQueries(keys.all);

                const user = queryClient.getQueryData<IEditUserDTO>(
                    keys.user(userID)
                );

                queryClient.setQueryData<IEditUserDTO>(
                    keys.user(userID), {...user, mfaSource: MfaSourceTypeEnum.Email} as IEditUserDTO
                );
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, _error, _user, _context) => {
            }
        }
    );
}
